
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { TimeSlot, DayOfWeek } from '@/models/Schedule';
import { useAuth } from '@/contexts/AuthContext';

export const useTimeSlotQueries = () => {
  const { currentOrganization } = useAuth();

  const {
    data: timeSlots = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['timeSlots', currentOrganization?.id],
    queryFn: async () => {
      if (!currentOrganization?.id) {
        console.log('No current organization, returning empty time slots list');
        return [];
      }

      console.log('Fetching time slots for organization:', currentOrganization.id);

      const { data, error } = await supabase
        .from('time_slots')
        .select('*')
        .eq('organization_id', currentOrganization.id)
        .eq('is_active', true)
        .order('day_of_week')
        .order('start_time');

      if (error) throw error;

      // Transform database data to frontend model
      return data.map((slot): TimeSlot => ({
        id: slot.id,
        day: slot.day_of_week as DayOfWeek,
        startTime: slot.start_time,
        endTime: slot.end_time,
        workoutTypeId: slot.workout_type_id,
        maxClients: slot.max_clients,
        isRecurring: false, // This field was removed from the database
        isActive: slot.is_active,
      }));
    },
    enabled: !!currentOrganization?.id,
  });

  return {
    timeSlots,
    isLoading,
    error,
  };
};
